const dashboardEn = {
    dashboard: require('../../lang/en/dashboard/Dashboard').default,
};

export default dashboardEn;